import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { EsusEnvioDetalhePage } from './envios/detalhe/EsusEnvioDetalhePage'
import { EsusEnvioListPage } from './envios/list/EsusEnvioListPage'

const enviosBreadcrumbs: Array<PageLink> = [
  {
    title: 'Envios e-SUS',
    path: '/apps/esus/lista',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

/**
 * Acompanhamento dos envios da Ficha de Atendimento Individual ao PEC e-SUS APS.
 *
 * Lista e detalhe não compartilham mais escolha de empresa porque não existe empresa em foco no
 * contrato: a rota é `/esus-envios` e o escopo de tenant é decidido no backend, a partir do usuário
 * autenticado. A empresa aparece como coluna/campo e como filtro opcional da listagem.
 */
const EsusPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='lista'
          element={
            <>
              <PageTitle description={t('pagina.esusEnvios.descricao')}>Envios e-SUS</PageTitle>
              <EsusEnvioListPage />
            </>
          }
        />
        <Route
          path='detalhes/:id'
          element={
            <>
              <PageTitle breadcrumbs={enviosBreadcrumbs}>Detalhe do envio</PageTitle>
              <EsusEnvioDetalhePage />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/esus/lista' />} />
    </Routes>
  )
}

export default EsusPage
